import { BASE_RANGE_TYPE } from '@/features/settings/capacity/components/types';

export const sortSchemesAlphabetically = <T extends { name: string; isDefault: boolean }>(
  schemes: T[],
): T[] => {
  return [...schemes].sort((a, b) => {
    if (a.isDefault && !b.isDefault) return -1;
    if (!a.isDefault && b.isDefault) return 1;
    return a.name.trim().localeCompare(b.name.trim());
  });
};

export const sortNamesAlphabetically = <T extends { name: string }>(items: T[]): T[] => {
  return [...items].sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
};

export const sortRangesByStartDateAsc = <T extends { startDate?: string }>(ranges: T[]): T[] => {
  return [...ranges].sort((a, b) => {
    if (!a.startDate && !b.startDate) return 0;
    if (!a.startDate) return -1;
    if (!b.startDate) return 1;
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  });
};

export const sortWorkloadRanges = <T extends { startDate?: string; type?: string }>(
  ranges: T[],
): T[] => {
  return [...ranges].sort((a, b) => {
    if (a.type === BASE_RANGE_TYPE && b.type !== BASE_RANGE_TYPE) return -1;
    if (a.type !== BASE_RANGE_TYPE && b.type === BASE_RANGE_TYPE) return 1;

    if (!a.startDate && !b.startDate) return 0;
    if (!a.startDate) return 1;
    if (!b.startDate) return -1;
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  });
};
